import React from 'react';
import { bool, number, string } from 'prop-types';
import classNames from 'classnames';
import ProfileImage from '@fiverr-private/profile_image';
import { PROFILE_IMAGE_SIZE } from './constants';

import './style.scss';

const Avatar = ({
    className,
    username,
    achievement,
    profilePhoto,
    isPro,
    isUnavailable = false,
    size = PROFILE_IMAGE_SIZE,
}) => {
    const profileImageUser = {
        username,
        achievement,
        has_profile_photo: !!profilePhoto,
        profile_photo: profilePhoto,
        is_pro: isPro,
    };

    const profileImageClassName = classNames('avatar', className, { unavailable: isUnavailable });

    return (
        <ProfileImage user={profileImageUser} profileImageSize={size} profileImageClassName={profileImageClassName} />
    );
};

Avatar.propTypes = {
    username: string,
    achievement: number,
    profilePhoto: string,
    isPro: bool,
    isUnavailable: bool,
    className: string,
    size: number,
};

export default Avatar;
